import { render, staticRenderFns } from "./MainPageComponent.vue?vue&type=template&id=2fd5b836&scoped=true&"
import script from "./MainPageComponent.vue?vue&type=script&lang=js&"
export * from "./MainPageComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainPageComponent.vue?vue&type=style&index=0&id=2fd5b836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5b836",
  null
  
)

export default component.exports